import { ErrorMessage, Field, Formik } from "formik";
import { TextField as Textfield } from "formik-mui";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Wrapper } from "../HOC";
import SelectInput from "../components/SelectInput";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { ImPlay2 } from "react-icons/im";
import { FaCloudUploadAlt } from "react-icons/fa";
import { ClaimSchema, initialClaim } from "../schemas/ContentSchema";
import { isEmpty } from "lodash";
import LoadingModal from "../components/Loader/LoadingModal";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../redux/modal/modalRedux";
import { useVault } from "../context/VaultContext";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const AddClaim = () => {
  const navigate = useNavigate();
  const { addclaim, setUploadImage, setValues, done, loader, uploadImage, addwithoutmedia } = useVault();
  const [previews, setPreviews] = useState([]);
  const imageRef = useRef();
  const dispatch = useDispatch();

  const options = ["Condo", "Duplex", "Triplex", "Apartment"];

  const handleSubmit = async (values, { resetForm }) => {
    if (uploadImage) {
      await addclaim(false);
      setValues(values);
    } else {
      await addwithoutmedia(values);
    }
    resetForm();
  };

  const handleMultipleImages = (evnt) => {
    const selectedFIles = [];
    const targetFiles = evnt.target.files;
    const targetFilesObject = [...targetFiles];
    targetFilesObject.map((file) => {
      return selectedFIles.push({ file: file, url: URL.createObjectURL(file) });
    });
    setPreviews(selectedFIles);
  };

  const photos = useMemo(() => {
    if (!isEmpty(previews)) {
      return Array.from(previews).filter(
        (image) => image.file.type === "image/png" || image.file.type === "image/jpg" || image.file.type === "image/jpeg"
      );
    }
  }, [previews]);

  const videos = useMemo(() => {
    if (!isEmpty(previews)) {
      return Array.from(previews).filter(
        (image) => image.file.type === "video/mp4" || image.file.type === "video/mp3" || image.file.type === "video/mkv"
      );
    }
  }, [previews]);

  useEffect(() => {
    if (done) {
      setPreviews([]);
      navigate('/claims');
    }
  }, [done, navigate]);

  useEffect(() => {
    if (loader) {
      dispatch(openModal());
    } else {
      dispatch(closeModal());
    }
  }, [dispatch, loader]);

  return (
    <Wrapper>
      <LoadingModal />
      <div className="w-[100%]">
        <p className="text-2xl font-bold">New Claim</p>
        <Formik onSubmit={handleSubmit} initialValues={initialClaim} validationSchema={ClaimSchema}>
          {({ handleSubmit, values, setFieldValue }) => (
            <div className="w-[60%] flex flex-col">
              <div className="pt-3 pb-6 grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"insuranceCompany"}
                      label="Insurance Co"
                      value={values.insuranceCompany || ""}
                      placeholder="insuranceCompany"
                      component={Textfield}
                      className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                  </div>
                </div>
                <div className="pt-1">
                  <SelectInput
                    options={options}
                    label="Select Property Type"
                    minWidth="md:w-full"
                    handleChange={(value) => setFieldValue("propertyType", value)}
                  />
                  <ErrorMessage
                    name={"propertyType"}
                    render={(msg) => <div className="text-[0.7812rem] text-red-600 font-roboto text-left ml-2 mt-1">{msg}</div>}
                  />
                </div>
                <div className="pt-3">
                  <div className="mt-1 relative flex">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="Date of Claim"
                        components={{
                          OpenPickerIcon: () => <i className="fa-solid fa-calendar-days text-primary"></i>,
                        }}
                        className="w-full"
                        inputFormat="DD-MMM-YYYY"
                        value={values?.dateOfClaim}
                        disableMaskedInput={true}
                        onChange={(value) => setFieldValue("dateOfClaim", dayjs(value).format("YYYY-MM-DD"))}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <ErrorMessage
                    name={"dateOfClaim"}
                    render={(msg) => <div className="text-[0.7812rem] text-red-600 font-roboto text-left ml-2 mt-1">{msg}</div>}
                  />
                </div>
                <div className="pt-3">
                  <div className="mt-1 relative flex">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                        label="Date of Loss"
                        components={{
                          OpenPickerIcon: () => <i className="fa-solid fa-calendar-days text-primary"></i>,
                        }}
                        className="w-full"
                        inputFormat="DD-MMM-YYYY"
                        value={values?.dateOfLoss}
                        disableMaskedInput={true}
                        onChange={(value) => setFieldValue("dateOfLoss", dayjs(value).format("YYYY-MM-DD"))}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <ErrorMessage
                    name={"dateOfLoss"}
                    render={(msg) => <div className="text-[0.7812rem] text-red-600 font-roboto text-left ml-2 mt-1">{msg}</div>}
                  />
                </div>
                <div>
                  <div className="pt-3">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        name={"claimName"}
                        label="Claim Name"
                        value={values.claimName || ""}
                        placeholder="25694236589"
                        component={Textfield}
                        className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                  <div className="pt-3">
                    <div className="mt-1 relative flex md:justify-end">
                      <Field
                        name={"claimNumber"}
                        label="Claim Number"
                        value={values.claimNumber || ""}
                        placeholder="25694236589"
                        component={Textfield}
                        className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                      />
                    </div>
                  </div>
                </div>
                <div className="pt-3">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"detailsOfLoss"}
                      multiline
                      rows={4}
                      label="Details of Loss"
                      value={values.detailsOfLoss || ""}
                      placeholder="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy"
                      component={Textfield}
                      className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                  </div>
                </div>
              </div>
              <div className="">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"claimType"}
                      label="Claim Type"
                      value={values.claimType || ""}
                      placeholder="claimType"
                      component={Textfield}
                      className="border w-full border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                  </div>
                </div>
              <div>
                <div className="pt-10">
                  <div className="flex items-center pb-3">
                    <label className="text-xs font-Medium cursor-pointer" htmlFor="imageUpload">
                      Add After Disaster Photos or Videos{" "}
                    </label>
                    <label className="pl-5" htmlFor="imageUpload">
                      <BsFillPlusCircleFill className="text-2xl text-primary cursor-pointer" />
                    </label>
                  </div>
                </div>
                <input
                  id="imageUpload"
                  type="file"
                  accept="image/*, video/*"
                  className="w-0.1 h-0.1 overflow-hidden hidden"
                  multiple
                  ref={imageRef}
                  onChange={(event) => {
                    setUploadImage(event.target.files);
                    handleMultipleImages(event);
                  }}
                />
                {previews.length > 0 && (
                  <button onClick={() => setPreviews([])} className="text-primary mb-2 self-end">
                    Remove all files
                  </button>
                )}
                <div className="flex items-center flex-wrap gap-2">
                  {photos?.map((item, index) => (
                    <div className="pr-5" key={index}>
                      <img src={item.url} alt="" height={100} width={100} />
                    </div>
                  ))}
                  {videos?.map((item, index) => (
                    <div className="relative" key={index}>
                      <video width={"100"} height={"100"} controls>
                        <source src={item.url} alt="" />
                      </video>
                      <div className="absolute top-0 bg-black bg-opacity-30 rounded-lg h-full w-full">
                        <div className="flex justify-center pt-14">
                          <ImPlay2 className="text-4xl text-white cursor-pointer" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex items-center justify-start py-5">
                <button
                  onClick={handleSubmit}
                  className="flex justify-center items-center py-3 px-7 border-2 border-primary text-primary rounded-md cursor-pointer hover:bg-primary hover:text-white"
                >
                  <FaCloudUploadAlt className="text-2xl" />
                  <p className="text-sm font-medium pl-3">Submit</p>
                </button>
              </div>
            </div>
          )}
        </Formik>
      </div>
    </Wrapper>
  );
};

export default AddClaim;
